import {
  provideDarkTheme,
  SOFTLINE_CONFIG_DEFAULT_THEME,
  SOFTLINE_CONFIG_THEMES,
} from '@softline/application';
import { CustomerConfig } from 'apps/softapps/src/customer-config.type';

export const customerConfig: CustomerConfig = {
  name: 'Schuberth Softline',
  id: 'at.softline.schuberth.softline',
  version: '0.0.0',
  providers: [
    { provide: SOFTLINE_CONFIG_DEFAULT_THEME, useValue: 'schuberth' },
    provideDarkTheme(false),
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'schuberth',
        name: 'Schuberth',
      },
      multi: true,
    },
    {
      provide: SOFTLINE_CONFIG_THEMES,
      useValue: {
        key: 'hagebau',
        name: 'Hagebau',
      },
      multi: true,
    },
  ],
  moduleConfig: { esl: ['storage', 'config'] },
};
